var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006191"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624664",
    x: 1.05566,
    y: 1.13184,
    width: 73.8882,
    height: 64.4022,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624673",
    x: 6.6228,
    y: 5.96936,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624674",
    x: 11.7307,
    y: 5.96936,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624675",
    x: 16.8386,
    y: 5.96936,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624666",
    x: 1.05566,
    y: 12.0773,
    width: 73.8882,
    height: 53.4568,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 509",
    d: "M23.3304 38.9762L35.7146 26.191L44.9028 44.963L26.826 46.5865M23.3304 38.9762L26.826 46.5865M23.3304 38.9762C20.7671 39.8895 16.6872 42.2129 17.7376 45.5718C18.3883 47.6524 19.6373 48.6671 21.2355 48.7809M26.826 46.5865C24.7793 48.1082 22.833 48.8945 21.2355 48.7809M26.826 46.5865L30.8232 55.7188L27.5275 57.5452L21.2355 48.7809",
    stroke: "#7646D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 510",
    d: "M42.3779 25.0593L44.9908 19.8336M47.8046 39.3295H58.4312M44.9908 32.4959L54.0353 28.2251",
    stroke: "#7646D7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.a2e1464b6bd01baf7bccb6698a59390d.svg";
export { ForwardRef as ReactComponent };